import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';

export type AccountRolesListFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly RolePayload[];
};

// Distinct from `RolesFetchedAction`: `rolesStore` writes this action into its own `accountRoles`
// location, never into the filtered, paginated `rolesList` that `RolesFetchedAction` owns.
export type AccountRolesFetchedAction = {
	type: 'ACCOUNT_ROLES_FETCHED';
	payload: AccountRolesListFetchedPayload;
	accountId: number;
};

export default (payload: AccountRolesListFetchedPayload, accountId: number): AccountRolesFetchedAction => ({
	type: 'ACCOUNT_ROLES_FETCHED',
	payload,
	accountId,
});
